import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      '&:hover': {
        cursor: 'pointer'
      }
    }
  },
  avatarRoot: {
    position: 'relative',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    '& .avatarBox': {
      position: 'relative',
      '& .cameraIcon': {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bottom: 0,
        right: 0,
        backgroundColor: colorSet.gray000,
        width: 36,
        height: 36,
        borderRadius: '50%',
        zIndex: 1,
        border: `1px solid ${colorSet.gray400}`,
        pointerEvents: 'none',
        '& svg': {
          fill: colorSet.gray700
        }
      },
      [theme.breakpoints.down('md')]: {
        marginRight: 16,
        '& .cameraIcon': {
          width: 28,
          height: 28,
          '& svg': {
            width: 16,
            height: 16
          }
        }
      }
    },
    '& .default_avatar': {
      width: 146,
      height: 146
    },
    '& .avatar': {
      width: 146,
      height: 146,
      borderRadius: '50%',
      border: 'none',
      backgroundColor: theme.palette.secondary.main
    },
    '& .userName': {
      ...theme.typography.body1,
      fontWeight: 500,
      marginTop: 20,
      marginBottom: 36,
      [theme.breakpoints.down('md')]: {
        fontWeight: 500,
        marginTop: 0,
        marginBottom: 2
      }
    },
    '& .changeButton': {
      backgroundColor: colorSet.gray900,
      marginBottom: 24,
      [theme.breakpoints.down('md')]: {
        width: 140,
        marginBottom: 32
      },
      '& svg': {
        width: 20,
        marginRight: 8
      }
    },
    '& .changeButtonLabel': {
      ...theme.typography.body2,
      lineHeight: 'unset'
    },
    [theme.breakpoints.down('md')]: {
      borderBottom: `1px solid ${colorSet.gray200}`,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      padding: '16px',
      '& .avatar': {
        width: 72,
        height: 72
      },
      '& .default_avatar': {
        width: 72,
        height: 72
      },
      '& .profileButton': {
        position: 'absolute',
        right: 0
      }
    }
  },
  avatarOverlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 500,
    position: 'absolute',
    width: 146,
    height: 146,
    borderRadius: '50%',
    top: 0,
    opacity: 0,
    '&:hover': {
      cursor: 'pointer',
      padding: '24px 0px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      backgroundColor: 'rgba(0,0,0,0.5)',
      opacity: 1,
      zIndex: 1
    },
    '& .text': {
      color: colorSet.gray000
    },
    '& svg': {
      color: '#dadada',
      width: 20
    },
    [theme.breakpoints.down('md')]: {
      top: 16,
      width: 72,
      height: 72
    }
  },
  listContainer: {},
  listRoot: {
    width: '100%',
    marginBottom: '24px',
    [theme.breakpoints.down('md')]: {
      padding: '0px'
    }
  },
  listItem: {
    height: 48,
    maxHeight: 48,
    marginBottom: 4,
    borderRadius: '8px',
    '&.collaps .MuiListItemText-root': {
      display: 'flex',
      paddingLeft: '24px'
    },
    '&.active': {
      backgroundColor: colorSet.gray100
    },
    [theme.breakpoints.down('md')]: {
      maxHeight: 56,
      height: '100%',
      marginBottom: 0,
      paddingRight: 0,
      borderRadius: '0px',
      '&:last-child': {
        borderBottom: `1px solid ${colorSet.gray200}`
      },
      '& .navBtn': {
        fill: theme.palette.text.secondary
      }
    }
  },

  listItemActive: {
    height: 48,
    maxHeight: 48,
    marginBottom: 4,
    borderRadius: '8px',
    [theme.breakpoints.down('md')]: {
      maxHeight: 56,
      height: '100%',
      borderTop: `1px solid ${colorSet.gray200}`,
      marginBottom: 0,
      '&:last-child': {
        borderBottom: `1px solid ${colorSet.gray200}`
      }
    }
  },
  listItemText: {
    color: colorSet.gray900,
    ...theme.typography.body2,
    fontWeight: 400,
    '&.active': {
      fontWeight: 500
    }
  },
  listItemDrop: {
    color: colorSet.gray900,
    ...theme.typography.body2,
    fontWeight: 500,
    textAlign: 'center'
  },
  listItemDropActive: {
    color: colorSet.primary500,
    ...theme.typography.body2,
    fontWeight: 500,
    textAlign: 'center'
  },
  listItemTextActive: {
    color: colorSet.gray900,
    ...theme.typography.body2,
    fontWeight: 500
  },
  listItemTextActiveSecondary: {
    backgroundColor: colorSet.gray100,
    ...theme.typography.body2,
    fontWeight: 500
  },
  listIcon: {
    color: colorSet.gray800,
    minWidth: 20,
    marginRight: 10,
    '& svg': {
      width: 20
    }
  },
  listIconActive: {
    color: colorSet.primary500,
    minWidth: 20,
    marginRight: 10,
    '& svg': {
      width: 20
    }
  },
  reddot: {
    height: 4,
    minWidth: 4,
    right: '-6px',
    top: '2px'
  },
  menuReddot: {
    marginRight: '37px'
  },
  logoutButton: {
    marginLeft: '16px',
    '& > span:first-child': {
      color: theme.palette.text.secondary
    },
    [theme.breakpoints.down('md')]: {
      '& > span:first-child': {
        color: theme.palette.text.secondary,
        textDecoration: 'underline'
      },
      marginTop: 16
    }
  }
}));
